import { useState } from "react";
import Welcome from "./Welcome";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { liveStudioApplicationFeature } from "../analytics";

const LOCAL_STORAGE_ITEM_NAME = "kms-live-preview-dont-show-welcome";

/**
 * Handles the display of the Welcome modal according to localStorage in the attendee preview screen
 */
export function PreviewWelcomeManager() {
    const sendButtonAnalytics = useButtonAnalytics();
    const [showWelcomeModal, setShowWelcomeModal] = useState(() => {
        const dontShowWelcome = localStorage.getItem(LOCAL_STORAGE_ITEM_NAME) === "true";
        return !dontShowWelcome;
    });

    const handleWelcomeClose = () => {
        sendButtonAnalytics(
            "Close Viewing as attendee modal",
            ButtonClickAnalyticsType.CLOSE,
            undefined,
            liveStudioApplicationFeature,
            "viewing as attendee modal",
            true
        );
        setShowWelcomeModal(false);
    };

    const handleDontShowAgainChange = (dontShowAgain: boolean) => {
        sendButtonAnalytics(
            (dontShowAgain ? "Don't " : "") + "show the Viewing as attendee modal",
            ButtonClickAnalyticsType.TOGGLE,
            undefined,
            liveStudioApplicationFeature,
            "viewing as attendee modal",
            true
        );
        localStorage.setItem(LOCAL_STORAGE_ITEM_NAME, dontShowAgain.toString());
    };

    return (
        <Welcome
            open={showWelcomeModal}
            onClose={handleWelcomeClose}
            onDontShowAgainChange={handleDontShowAgainChange}
            title={translate("Viewing as an attendee")}
            contentText={translate(
                "This is how attendees will see your broadcast. Click the Studio view to return to the studio.<br><br>Note: A delay between the studio and live player is expected."
            )}
        />
    );
}

export default PreviewWelcomeManager;
